export const RESET_ORDER_ISFETCHING = 'RESET_ORDER_ISFETCHING';
export const GET_ORDER_REQUEST = 'GET_ORDER_REQUEST';
export const GET_CUSTOMER_ORDER_REQUEST = 'GET_CUSTOMER_ORDER_REQUEST';
export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS';
export const LIST_ORDERS_REQUEST = 'LIST_ORDERS_REQUEST';
export const ORDER_LIST_REQUESTING = 'ORDER_LIST_REQUESTING';
export const ORDER_OBJECT_REQUESTING = 'ORDER_OBJECT_REQUESTING';
export const LIST_ORDERS_SUCCESS = 'LIST_ORDERS_SUCCESS';
